import clsx from 'clsx';
import { useContext } from 'react';

import { findCurrencyItemByValue, getCurrencyList } from 'src/tools/currency.tools';
import { ifTrue } from 'src/tools/logic.tools';

import { InputContext } from 'src/contexts/input.context';
import { CurrencyItem } from 'src/models/currency.model';
import { ButtonBaseType, Maybe } from 'src/models/general.model';

import { InlineInput } from 'src/components/Inputs/InlineInput';
import { P3 } from 'src/components/Typography';
import { SearchableDropdown, SearchableDropdownInputProps } from '../SearchableDropdown';

import classes from './CurrencyDropdown.module.scss';

export function CurrencyDropdown() {
  const { isDisabled, isReadonly, isAutoFocus, classNames } = useContext(InputContext);

  function renderCurrencyElement(item: CurrencyItem, isSelected: boolean, isActive: boolean) {
    return (
      <div
        className={clsx('row a-center j-start', classes.container, {
          [classes.selected]: isSelected,
          [classes.active]: isActive,
        })}
      >
        <img src={item.flag} className={clsx(classes.flag, ifTrue(!item.flag, classes['zero-height']))} />
        <div className={classes.space} />
        <P3>{item.label}</P3>
      </div>
    );
  }

  function renderFlag(item: Maybe<CurrencyItem>) {
    if (item?.flag) return <img src={item.flag} className={classes.flag} />;

    return <div className={clsx(classes.flag, classes['zero-height'])} />;
  }

  function renderInput({
    value,
    onFocus,
    onClick,
    onBlur,
    onDiscard,
    onSubmit,
    onChange,
  }: SearchableDropdownInputProps) {
    const item = findCurrencyItemByValue(value);

    return (
      <div className='row a-center'>
        {ifTrue(isDisabled, renderFlag(item))}
        <InlineInput
          className={classNames?.input}
          value={item ? `${item?.symbol} ${item?.id}` : value}
          onChange={onChange}
          onFocus={onFocus}
          onClick={onClick}
          onBlur={onBlur}
          isDisabled={isDisabled}
          autoFocus={isAutoFocus}
          onDiscard={onDiscard}
          onSubmit={onSubmit}
          isReadonly={isReadonly}
        />
      </div>
    );
  }

  return (
    <SearchableDropdown
      isSearchable
      items={getCurrencyList()}
      renderItemLabel={renderCurrencyElement as (item: ButtonBaseType, isSelected: boolean) => string | JSX.Element}
      renderInput={renderInput}
      isStrictSearch
    />
  );
}
